import { v4 as uuidv4 } from "uuid";

export const getTXOneAccountUrl = () => {
  return process.env.REACT_APP_TXONE_ACCOUNT_URL;
};

export const getSSOClientId = () => {
  return process.env.REACT_APP_SSO_CLIENT_ID;
};

export const getSSORedirectUri = () => {
  return process.env.REACT_APP_SSO_REDIRECT_URI;
};

export const generateUUID = () => {
  return uuidv4();
};

export * from "./license";
export * from "./common";
export * as formSchema from "./formSchema";
export * as accessControl from "./access_control";
